import _extends from "@babel/runtime/helpers/extends";
import TextField from "@material-ui/core/esm/TextField";
import Typography from "@material-ui/core/esm/Typography";
import Autocomplete from "@material-ui/lab/esm/Autocomplete";
import { nanoid } from 'nanoid';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormElement } from 'components/Form';
import useFuelType from './useFuelType';
const idSuffix = nanoid();
export default function FuelType({
  control
}) {
  const {
    t
  } = useTranslation();
  const {
    fuelTypeList,
    getCodes
  } = useFuelType();
  const inputId = `fuelType_${idSuffix}`;
  return /*#__PURE__*/React.createElement(FormElement, {
    title: t('vehicles.fuel_type'),
    childId: inputId
  }, /*#__PURE__*/React.createElement(Controller, {
    name: "fuelType",
    defaultValue: null,
    control: control,
    rules: {
      required: true
    },
    render: ({
      onBlur,
      onChange,
      ...props
    }) => /*#__PURE__*/React.createElement(Autocomplete, _extends({
      defaultValue: null,
      placeholder: t('vehicles.fuel_type'),
      options: getCodes,
      getOptionLabel: option => option ? `${fuelTypeList[option].codeDescription} - ${option}` : '',
      onChange: (_e, data) => onChange(data),
      onBlur: onBlur,
      style: {
        width: 300
      },
      renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: t('vehicles.fuel_type'),
        variant: "outlined",
        InputProps: {
          ...params.InputProps,
          endAdornment: params.InputProps.endAdornment
        }
        // eslint-disable-next-line react/jsx-no-duplicate-props
        ,
        inputProps: {
          ...params.inputProps,
          id: inputId
        }
      })),
      renderOption: option => /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1"
      }, option && fuelTypeList ? `${fuelTypeList[option].codeDescription} - ${option}` : '')
    }, props))
  }));
}